export const BACKGROUND_IMAGE_ATTRIBUTE = 'background-image';
export const BACKGROUND_POSITION_ATTRIBUTE = 'background-position';
export const BACKGROUND_SCALE_ATTRIBUTE = 'background-scale';
export const BACKGROUND_HIDDEN_ATTRIBUTE = 'background-hidden';
export const BACKGROUND_PLACEHOLDER_ATTRIBUTE = 'background-placeholder';
